var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTakeTwoInteractiveLogowine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 800,
    width: 1200,
    viewBox: "-75 -118.7645 650 712.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathS)",
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-393.41 -258.656)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathZ)",
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-370.599 -258.656)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathe)",
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathq)",
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-338.608 -258.656)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathAj)",
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-324.112 -263.932)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPath3c)",
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-299.76 -264.671)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPath1W)",
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-278.489 -267.287)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathM)",
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-264.266 -258.656)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathMv)",
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-242.805 -258.656)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathT)",
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-224.299 -258.656)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPath4Q)",
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathIy)",
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathu)",
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-402.837 -482.288)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathR)",
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-394.789 -490.927)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathqp)",
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-384.492 -289.891)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathV)",
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-362.909 -281.996)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathP)",
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-330.808 -281.957)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathy)",
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-291.858 -281.91)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathE)",
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-262.05 -281.874)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathiG)",
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-233.576 -288.437)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathSZ)",
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-210 -281.812)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathFY)",
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-392.889 -313.934)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathuC)",
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-392.889 -313.934)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPathO)",
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-253.318 -314.017)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPath: "url(#clipPath38)",
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-253.318 -314.017)",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.44 490.928h244.897V257.985H166.44z",
    id: "a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-51.293-.062-.16 133.621-36.932-.044-.05 42.317 124.385.149.052-42.317-36.162-.043L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 177.529 361.503)",
    clipPath: "url(#b)",
    fill: "#1476c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-51.293-.062-.16 133.621-36.932-.044-.05 42.317 124.385.149.052-42.317-36.162-.043L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 177.529 361.503)",
    clipPath: "url(#c)",
    fill: "#1476c6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-130.741-.157-.047 39.323 58.304 43.903c10.509 9.029 23.02 19.563 23.001 34.591-.011 10.019-6.283 18.026-16.802 18.013-16.03-.019-20.518-16.555-21.254-29.83l-43.339 8.464c4.715 36.823 31.235 59.898 68.303 59.942 34.314.041 63.389-18.458 63.434-55.527.023-18.534-8.476-32.32-21.987-44.358l-39.788-29.855L-64.92 42l66.873.08L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 462.732 361.672)",
    clipPath: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-130.741-.157-.047 39.323 58.304 43.903c10.509 9.029 23.02 19.563 23.001 34.591-.011 10.019-6.283 18.026-16.802 18.013-16.03-.019-20.518-16.555-21.254-29.83l-43.339 8.464c4.715 36.823 31.235 59.898 68.303 59.942 34.314.041 63.389-18.458 63.434-55.527.023-18.534-8.476-32.32-21.987-44.358l-39.788-29.855L-64.92 42l66.873.08L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 462.732 361.672)",
    clipPath: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-1.016h2.91v-7.623h1.178v7.623h2.909V0H0",
    transform: "matrix(2.04343 0 0 -2.04343 466.614 0)",
    clipPath: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1.109v5.098c0 .201-.01.522-.024.955-.017.433-.023.756-.023.97v.262L3.556 0h1.163l2.508 7.285c0-.465-.009-.903-.023-1.31a22.448 22.448 0 01-.023-.877V0H8.29v8.639H6.63L4.144 1.334 1.665 8.639H0V0",
    transform: "matrix(2.04343 0 0 -2.04343 483.06 17.653)",
    clipPath: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-4.629-.006-.014 12.058-3.333-.003-.005 3.818 11.225.014.005-3.819-3.263-.004L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 89.012 427.311)",
    clipPath: "url(#h)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-1.301 4.604-1.291-4.607zm.837-3.471l-4.235-.005-.968-3.125-3.958-.005 4.911 15.883 5.138.006L6.72-6.588l-4.976-.006-.907 3.123",
    transform: "matrix(2.04343 0 0 -2.04343 137.188 413.774)",
    clipPath: "url(#i)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-2.739 5.991-1.663-2.316.004-3.68L-8.98-.01l-.019 15.877 4.582.004.008-6.549 4.39 6.555 4.374.005-3.997-5.814L5.346.007 0 0",
    transform: "matrix(2.04343 0 0 -2.04343 195.372 427.185)",
    clipPath: "url(#j)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-11.918-.015-.019 15.877 11.918.015.004-3.657-7.151-.009.004-2.314 5.784.007.005-3.541-5.785-.007.003-2.569 7.15.008L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 256.283 427.111)",
    clipPath: "url(#k)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.448 287.635h-9.565v4.474h9.565z",
    transform: "matrix(2.04343 0 0 -2.04343 -340.108 1003.173)",
    clipPath: "url(#l)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-4.629-.005-.014 12.057-3.332-.004-.005 3.819 11.224.014.005-3.819-3.263-.004L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 335.874 427.015)",
    clipPath: "url(#m)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-4.096-.005-2.21 8.745h-.046L-8.401-.01l-4.258-.006-4.255 15.872 4.583.005 2.209-9.162h.046l2.142 9.168 3.819.004 2.348-9.162h.046l2.188 9.168 3.727.005L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 401.47 426.935)",
    clipPath: "url(#n)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.002-1.527.168-4.466 2.389-4.464C4.611-4.462 4.77-1.522 4.768.005c-.002 1.551-.238 4.652-2.39 4.65C.226 4.652-.002 1.551 0 0zm9.975.035c.005-4.513-2.768-8.126-7.582-8.132-4.813-.006-7.595 3.601-7.6 8.114-.006 4.745 2.744 8.219 7.581 8.225 4.837.006 7.595-3.463 7.601-8.207",
    transform: "matrix(2.04343 0 0 -2.04343 445.573 410.802)",
    clipPath: "url(#o)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M206.911 258.656h-4.474v14.476h4.474z",
    transform: "matrix(2.04343 0 0 -2.04343 -340.108 1003.173)",
    clipPath: "url(#p)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-4.157 6.774-1.288 2.617-.042-.042.042-.169c.212-.929.296-1.436.296-2.427V0h-3.609v14.476h4.2L.295 6.394l.043.042-.317 4.01v4.03h3.608V0H0",
    transform: "matrix(2.04343 0 0 -2.04343 118.23 474.629)",
    clipPath: "url(#q)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-4.22v10.994h-3.039v3.482H2.976v-3.482H0V0",
    transform: "matrix(2.04343 0 0 -2.04343 156.046 474.629)",
    clipPath: "url(#r)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-10.868v14.476H0v-3.334h-6.52v-2.11h5.275V5.803H-6.52V3.461H0V0",
    transform: "matrix(2.04343 0 0 -2.04343 199.9 474.629)",
    clipPath: "url(#s)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.971 0 2.131.147 2.131 1.393 0 .486-.253.949-.697 1.182-.379.189-.843.189-1.265.189h-1.794V0zm1.878-8.631l-2.11 5.529h-1.393v-5.529H-6.12V5.845h7.365c1.266 0 2.659-.168 3.735-.886 1.203-.76 1.773-2.046 1.773-3.461 0-1.898-.845-3.038-2.554-3.819l2.617-6.31H1.878",
    transform: "matrix(2.04343 0 0 -2.04343 228.964 456.992)",
    clipPath: "url(#t)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l-1.181 4.199L-2.363 0zm.759-3.165h-3.861l-.887-2.849h-3.608l4.495 14.476h4.684L6.119-6.014H1.582L.759-3.165",
    transform: "matrix(2.04343 0 0 -2.04343 272.43 462.338)",
    clipPath: "url(#u)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.275-3.334-2.701-5.486-6.035-5.486-4.347 0-6.627 3.144-6.627 7.259 0 4.178 2.005 7.639 6.563 7.639 3.693 0 5.803-2.195 6.099-5.803l-4.137-.212c.043 1.225-.421 2.765-1.919 2.765-1.963 0-2.047-3.018-2.047-4.389 0-1.456.084-3.925 2.089-3.925 1.371 0 1.899 1.202 1.962 2.405L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 322.191 463.848)",
    clipPath: "url(#v)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-4.221v10.994H-7.26v3.482H2.975v-3.482H0V0",
    transform: "matrix(2.04343 0 0 -2.04343 351.813 474.629)",
    clipPath: "url(#w)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M353.781 258.656h-4.474v14.476h4.474z",
    transform: "matrix(2.04343 0 0 -2.04343 -340.108 1003.173)",
    clipPath: "url(#x)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-4.537L-9.2 14.476h4.663l2.279-7.829.423-1.435.401 1.372 2.279 7.892h3.65L0 0",
    transform: "matrix(2.04343 0 0 -2.04343 417.184 474.629)",
    clipPath: "url(#y)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-10.868v14.476H0v-3.334h-6.521v-2.11h5.276V5.803h-5.276V3.461H0V0",
    transform: "matrix(2.04343 0 0 -2.04343 463.797 474.629)",
    clipPath: "url(#z)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeTwoInteractiveLogowine);
export default __webpack_public_path__ + "static/media/Take-Two_Interactive-Logo.wine.6f5980d4020a36a961fb2413583f0eeb.svg";
export { ForwardRef as ReactComponent };